import React from 'react';
import { Box, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import {
  CallStatsFilters,
  TimeWindow,
} from '../../../store/callStats/callStatsTypes';

interface Props {
  window: TimeWindow;
  from?: string;
  to?: string;
  onChange: (patch: Partial<CallStatsFilters>) => void;
}

const PRESETS: { value: TimeWindow; label: string }[] = [
  { value: '1h', label: '1H' },
  { value: '3h', label: '3H' },
  { value: '6h', label: '6H' },
  { value: '1d', label: '1D' },
  { value: '7d', label: '7D' },
  { value: 'custom', label: 'Custom' },
];

const TimeRangeFilter: React.FC<Props> = ({ window, from, to, onChange }) => {
  const handlePreset = (
    _: React.MouseEvent<HTMLElement>,
    next: TimeWindow | null,
  ) => {
    if (!next) return;
    if (next === 'custom') {
      onChange({
        window: 'custom',
        from: from ?? moment.utc().subtract(1, 'day').toISOString(),
        to: to ?? moment.utc().toISOString(),
      });
    } else {
      onChange({ window: next });
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
      <ToggleButtonGroup
        value={window}
        exclusive
        size="small"
        onChange={handlePreset}
        color="secondary"
      >
        {PRESETS.map((p) => (
          <ToggleButton key={p.value} value={p.value} sx={{ px: 1.75 }}>
            {p.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      {window === 'custom' && (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Box display="flex" gap={1.5} alignItems="center">
            <DateTimePicker
              label="From"
              value={from ? moment(from) : null}
              maxDateTime={to ? moment(to) : moment()}
              onChange={(v) =>
                v && onChange({ window: 'custom', from: v.toISOString() })
              }
              renderInput={(params) => (
                <TextField {...params} size="small" sx={{ width: 210 }} />
              )}
            />
            <DateTimePicker
              label="To"
              value={to ? moment(to) : null}
              minDateTime={from ? moment(from) : undefined}
              maxDateTime={moment()}
              onChange={(v) =>
                v && onChange({ window: 'custom', to: v.toISOString() })
              }
              renderInput={(params) => (
                <TextField {...params} size="small" sx={{ width: 210 }} />
              )}
            />
          </Box>
        </LocalizationProvider>
      )}
    </Box>
  );
};

export default TimeRangeFilter;
